import React from "react";

import { isRenewal, quotePageCartName } from "QuotePage/urls";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import AnalyticsTracking from "Utils/AnalyticsTracking";

import { NavBarMenuItem } from "Cobalt/NavBar";
import { NavItem } from "Cobalt/NavItem";
import { getCartItems } from "Common/CartService";
import Icon from "Common/Icon";

import makeBem from "Utils/makeBem";

const ANALYTICS_LOCATION = "quote_page_cart";

const QuotePageShoppingCartDumb = ({ quoteSummaryItemCount, onClickQuoteSummaryLink }) => (
  <NavBarMenuItem
    key="shoppingCart"
    className="cursor-pointer border-0 bg-transparent p-2 text-base !text-white no-underline hover:!no-underline hover:!text-white focus:!text-white"
    onClick={onClickQuoteSummaryLink}
  >
    <Icon icon="shopping-cart" size="lg" count={`${quoteSummaryItemCount}`} />
  </NavBarMenuItem>
);

const mapStateToProps = (state, { history }) => {
  const onClickQuoteSummaryLink = () => {
    AnalyticsTracking.trackEvent("cart_viewed", {
      location: ANALYTICS_LOCATION,
    });

    history.push(quotePageCartName(isRenewal()));
  };

  return {
    quoteSummaryItemCount: getCartItems(state),
    onClickQuoteSummaryLink,
  };
};

const QuotePageShoppingCart = withRouter(connect(mapStateToProps)(QuotePageShoppingCartDumb));

export default QuotePageShoppingCart;
